import { compose } from "recompose";

import { withLocalService } from "@dpdgroupuk/mydpd-app";
import { withSnackbar } from "@dpdgroupuk/mydpd-ui";

import withController from "./withController";

export default compose(withSnackbar, withLocalService, withController);
